module.exports = __webpack_public_path__ + "static/media/banner_beauty.9dc185b8.png";